import React from "react";
import {Col, Row} from "react-bootstrap";

const CardProfile = ({userData}) =>{

        return (
            <Row className="card g-0 mb-3">
                <Col xs={12}>
                    <div className="card-body">
                        <div className="card-information">
                            <p className={'mb-0'}>Titolo: {userData.title}</p>
                            <p className={'mb-0'}>Nome: {userData.firstName}</p>
                            <p className={'mb-0'}>Cognome: {userData.lastName}</p>
                            <p className={'mb-0'}>e-mail: {userData.email}</p>
                            <p className={'mb-0'}>password: &#x2022;&#x2022;&#x2022;&#x2022;&#x2022;&#x2022;&#x2022;</p>
                        </div>
                    </div>
                </Col>
            </Row>
        )
}
export default CardProfile;